import {
  createContext, Dispatch, useContext, useMemo,
} from 'react';
import { IAction } from '../../../store/modules/root/i-action';
import { IActions } from '../../../store/modules/root/i-actions';
import { UserActions } from '../../../store/modules/user/user.actions';
import { IApiService } from '../../../store/services/api-service';
import { IState } from '../../../store/modules/root/state.interface';
import { ILocalStorageService } from '../../../store/services/local-storage-service';
import { TenantsActions } from '../../../store/modules/tenants/tenant.actions';
import { FacilityActions } from '../../../store/modules/facility/facility.actions';
import { AssetsActions } from '../../../store/modules/asset/asset.actions';
import { ReportActions } from '../../../store/modules/report/report.actions';
import { DevicesActions } from '../../../store/modules/devices/devices.actions';
import { RuleActions } from '../../../store/modules/rules/rules.actions';

export const ActionsContext = createContext<IActions>({} as IActions);

export const useActions = (): IActions => useContext<IActions>(ActionsContext);

export const useGetActions = (
  state: IState,
  dispatch: Dispatch<IAction>,
  api: IApiService,
  localStorageService: ILocalStorageService,
): IActions => ({
  userActions: useMemo(
    () => new UserActions(state, api, dispatch, localStorageService),
    [state, dispatch, api, localStorageService],
  ),
  tenantActions: useMemo(
    () => new TenantsActions(state, api, dispatch, localStorageService),
    [state, dispatch, api, localStorageService],
  ),
  facilityActions: useMemo(() => new FacilityActions(state, api, dispatch), [
    state,
    dispatch,
    api,
  ]),
  assetActions: useMemo(() => new AssetsActions(state, api, dispatch), [
    state,
    dispatch,
    api,
  ]),
  reportActions: useMemo(() => new ReportActions(state, api, dispatch), [
    state,
    dispatch,
    api,
  ]),
  devicesActions: useMemo(() => new DevicesActions(state, api, dispatch), [
    state,
    dispatch,
    api,
  ]),
  ruleActions: useMemo(() => new RuleActions(state, api, dispatch), [state, dispatch, api]),
});
